var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-content-slider carousel-box"},[_c('NoSsr',[_c('VSplide',{ref:"carousel",staticClass:"owl-carousel owl-theme",attrs:{"options":_vm.carouselOpts}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }